export default __webpack_public_path__ + "static/media/closeBtn.678e586d.svg";